<template>
	<!-- 倒數計時器本體 -->
    <v-card 
        style="height:100%;" 
        class="d-flex flex-column mr-3 pa-3"
        elevation="0"
    >
        <!-- {{config.selected_setting}} -->
		<v-card-title
			class="text_primary pl-0"
		>
			<span> {{config.selected_setting_tab_name}}</span>
			<v-spacer></v-spacer>

		</v-card-title>
		<!-- <v-divider></v-divider> -->

        <v-card-text style="height:100%;" class="d-flex align-center">
            <div class="count_timer_container" :style="{
                height: config.iframe_height + 'px',
                backgroundImage: getGradient
            }">
                <div class="count_timer">
                    <article class="count_timer_header">
                        <h2
                            id="t_description"
                            class="description"
                            :style="{
                                fontSize: config.selected_setting.campaign_text.size + 'px',
                                color: config.selected_setting.campaign_text.color
                            }"
                        >
                            {{config.selected_setting.campaign_text.text}}
                        </h2>
                    </article>
                    <span id="from" style="height: 0px; color: transparent;">
                    </span>
                    <article class="count_timer_body">

                        <div class="units_container">
                            <div id="t_days" class="number"
                                :style="{
                                    backgroundImage: getNumberGradient,
                                    fontSize: getNumberFontSize
                                }"
                            >
                                00
                            </div>
                            <div id="t_days_unit" class="unit" 
                                :style="{
                                    fontSize:  getUnitFontSize,
                                    color: getUnitColor
                                }"
                            >
                                天
                            </div>
                        </div>

                        <div class="symbol_container"
                            :style="{
                                marginLeft: getSymbolSpacing,
                                marginRight: getSymbolSpacing,
                            }"
                        >
                            <span 
                                class="symbol" 
                                :style="{
                                    fontSize: getSymbolFontSize,
                                    color: getSymbolColor,
                                    top: getSymbolTop
                                }"
                            >:</span>
                        </div>

                        <div class="units_container">
                            <div id="t_hours" class="number"
                                :style="{
                                    backgroundImage: getNumberGradient,
                                    fontSize: getNumberFontSize
                                }"
                            >
                                00
                            </div>
                            <div id="t_hours_unit" class="unit"
                                :style="{
                                    fontSize:  getUnitFontSize,
                                    color: getUnitColor
                                }"
                            >
                                時
                            </div>
                        </div>	

                        <div class="symbol_container"
                            :style="{
                                marginLeft: getSymbolSpacing,
                                marginRight: getSymbolSpacing,
                            }"
                        >
                            <span 
                                class="symbol" 
                                :style="{
                                    fontSize: getSymbolFontSize,
                                    color: getSymbolColor,
                                    top: getSymbolTop
                                }"
                            >:</span>
                        </div>

                        <div class="units_container">
                            <div id="t_minutes" class="number"
                                :style="{
                                    backgroundImage: getNumberGradient,
                                    fontSize: getNumberFontSize
                                }"
                            >
                                00
                            </div>
                            <div id="t_minutes_unit" class="unit"
                                :style="{
                                    fontSize:  getUnitFontSize,
                                    color: getUnitColor
                                }"
                            >
                                分
                            </div>
                        </div>

                        <div class="symbol_container"
                            :style="{
                                marginLeft: getSymbolSpacing,
                                marginRight: getSymbolSpacing,
                            }"
                        >
                            <span 
                                class="symbol" 
                                :style="{
                                    fontSize: getSymbolFontSize,
                                    color: getSymbolColor,
                                    top: getSymbolTop
                                }"
                            >:</span>
                        </div>
                        
                        <div class="units_container">
                            <div id="t_seconds" class="number sec"
                                :style="{
                                    backgroundImage: getNumberGradient,
                                    fontSize: getNumberFontSize
                                }"
                            >
                                00
                            </div>
                            <div id="t_seconds_unit" class="unit"
                                :style="{
                                    fontSize:  getUnitFontSize,
                                    color: getUnitColor
                                }"
                            >
                                秒
                            </div>
                        </div>														
                    </article>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
	export default {
		name: 'Timer',
        props: {
            config: Object
        },
		components: {

		},
		data: function() {
			return {		
                countdown_timer: null,
			}
		},
        created: async function(){
            this.config.selected_setting = this.config.settings[0]
        },
		mounted: async function() {
		},
        destroyed: function(){
            this.clearTimer()
        },
		methods: {
            resetTimer: function(config){
                this.clearTimer()
                console.log('now_type',config.selected_setting.type)
                console.log('repeat_day', config.add_column.repeat_day)
                let that = this
                let distance = null

                let start_at = config.start_at
                let end_at = config.end_at
                let campaign_start_at = config.campaign_start_at
                let campaign_end_at = config.campaign_end_at


                if (!start_at || !end_at || !campaign_start_at || !campaign_end_at) {
                    document.getElementById("t_days").innerText = '00'
                    document.getElementById("t_hours").innerText = '00'
                    document.getElementById("t_minutes").innerText = '00'						
                    document.getElementById("t_seconds").innerText = '00'	
                    return
                }


                console.log('start_at', start_at)
                console.log('end_at', end_at)
                console.log('c_start_at', campaign_start_at)
                console.log('c_end_at', campaign_end_at)

                switch (config.selected_setting.type) {

                    // 如果是活動前就顯示campaign_start_at - now
                    case 'warm_up':
                        distance = new Date(campaign_start_at).getTime() - new Date().getTime()
                        if (distance <= 0) {
                            distance = new Date(campaign_start_at).getTime() - new Date(start_at).getTime()
                        }
                        console.log('warm_up_duration:',distance)
                        var unit = this.getCountDownUnit(distance)
                        document.getElementById("t_days").innerText = unit.t_days
                        document.getElementById("t_hours").innerText = unit.t_hours
                        document.getElementById("t_minutes").innerText = unit.t_minutes				
                        document.getElementById("t_seconds").innerText = unit.t_seconds

                        this.countdown_timer = setInterval(function() {
                            distance = distance - 1000
                            if (distance < 0){
                                clearInterval(that.countdown_timer);
                                document.getElementById("t_days").innerText = '00'
                                document.getElementById("t_hours").innerText = '00'
                                document.getElementById("t_minutes").innerText = '00'						
                                document.getElementById("t_seconds").innerText = '00'			
                                return
                            }

                            let show_units = that.getCountDownUnit(distance)
                            //console.log(show_units)
                            let units = Object.keys(show_units)
                            units.forEach(function(unit){
                                document.getElementById(unit).innerText = show_units[unit]
                            })

                        }, 1000);
                        break;

                    // 如果是活動中就顯示 preview_at - now_at
                    case 'campaign':
                        distance = new Date(campaign_end_at).getTime() - new Date().getTime()
                        if (new Date(campaign_end_at).getTime() > new Date().getTime()) {
                            distance = new Date(campaign_end_at).getTime() - new Date(campaign_start_at).getTime()
                        }
                        if (distance <= 0) {
                            if (!config.add_column.repeat_day || isNaN(parseInt(config.add_column.repeat_day))) {
                                distance = new Date(campaign_end_at).getTime() - new Date(campaign_start_at).getTime()
                            }
                            else {
                                let repeat_day_second = parseInt(config.add_column.repeat_day) *  24 * 60 * 60 * 1000
                                let lost_duration = 0
                                if (new Date().getTime() - campaign_end_at.getTime() < repeat_day_second) {
                                    console.log('進1')
                                    lost_duration = repeat_day_second - (new Date().getTime() - campaign_end_at.getTime())  
                                }
                                else {
                                    console.log('進2')
                                    lost_duration = repeat_day_second - (new Date().getTime() - campaign_end_at.getTime() )% repeat_day_second
                                }

                                distance = lost_duration
                            }
                            
                        }
                        this.countdown_timer = setInterval(function() {
                            distance = distance - 1000
                            if (distance < 0){
                                clearInterval(that.countdown_timer);
                                document.getElementById("t_days").innerText = '00'
                                document.getElementById("t_hours").innerText = '00'
                                document.getElementById("t_minutes").innerText = '00'						
                                document.getElementById("t_seconds").innerText = '00'			
                                return
                            }

                            let show_units = that.getCountDownUnit(distance)
                            //console.log(show_units)
                            let units = Object.keys(show_units)
                            units.forEach(function(unit){
                                document.getElementById(unit).innerText = show_units[unit]
                            })

                        }, 1000);

                        break;
                    
                    // 如果是活動後就顯示 00:00:00:00
                    case 'over':
                        document.getElementById("t_days").innerText = '00'
                        document.getElementById("t_hours").innerText = '00'
                        document.getElementById("t_minutes").innerText = '00'					
                        document.getElementById("t_seconds").innerText = '00'
                        break;
                }

                

                

            },
            clearTimer: function(){
                clearInterval(this.countdown_timer)
            },
            getCountDownUnit(distance) {
                    
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                days = days.toString()
                if (days.length === 1) {
                    days = '0' + days
                }
                hours = hours.toString()
                if (hours.length === 1) {
                    hours = '0' + hours
                }				
                minutes = minutes.toString()
                if (minutes.length === 1) {
                    minutes = '0' + minutes
                }	
                seconds = seconds.toString()
                if (seconds.length === 1) {
                    seconds = '0' + seconds
                }	
                
                let result = {
                    t_days: days,
                    t_hours: hours,
                    t_minutes: minutes,
                    t_seconds: seconds
                }
                return result
            }
		},
        computed: {
            getGradient: function(){
                let start_color = this.config.selected_setting.background_1.color ? this.config.selected_setting.background_1.color : '#334163FF' 
                let end_color = this.config.selected_setting.background_2.color ? this.config.selected_setting.background_2.color : '#724448FF' 
                return 'linear-gradient(62deg,' + start_color  + ' 0%, ' + end_color  + ' 100%)'
            },
            getNumberGradient: function(){
                let start_color = this.config.add_column.timer_style.time_1.color ? this.config.add_column.timer_style.time_1.color : '#334163FF' 
                let end_color = this.config.add_column.timer_style.time_2.color ? this.config.add_column.timer_style.time_2.color : '#724448FF' 
                return 'linear-gradient(62deg,' + start_color  + ' 0%, ' + end_color  + ' 100%)'
            },
            getNumberFontSize: function() {
                return this.config.add_column.timer_style.time_size + 'px'
            },
            getUnitFontSize: function(){
                return this.config.add_column.timer_style.unit.size + 'px'
            },
            getUnitColor: function(){
                return this.config.add_column.timer_style.unit.color
            },
            getSymbolFontSize: function(){
                return this.config.add_column.timer_style.symbol.size + 'px'
            },
            getSymbolColor: function(){
                return this.config.add_column.timer_style.symbol.color
            },
            getSymbolTop: function(){
                return this.config.add_column.timer_style.symbol.top + 'px'
            }, 
            getSymbolSpacing: function(){
                return this.config.add_column.timer_style.symbol.letter_spacing + 'px'
            },
            getWarmUpTime: function(){
                let start_at = ''
                if (this.config.start_at) {
                    start_at = this.$utils.getYYYYMMDDHHMMSS(this.config.start_at, '-') 
                }
                let end_at = ''
                if (this.config.campaign_start_at) {
                    end_at = this.$utils.getYYYYMMDDHHMMSS(this.config.campaign_start_at, '-') 
                }
                let duration = {
                    "start_at": start_at,
                    "end_at":  end_at 
                }
                return duration
            },
            getCampaignTime: function(){
                return this.$utils.getYYYYMMDDHHMMSS(this.config.campaign_start_at, '-')  + ' ~ ' + this.$utils.getYYYYMMDDHHMMSS(this.config.campaign_end_at, '-')
            },
            getOverTime: function(){
                return this.$utils.getYYYYMMDDHHMMSS(this.config.campaign_end_at, '-')  + ' ~ ' + this.$utils.getYYYYMMDDHHMMSS(this.config.end_at, '-')
            }
        },
        watch: {
            config: {
                deep: true,
                handler(newValue) {
                    // preview 沒有停住
                    // if (!newValue.preview_at) {
                    //     this.clearTimer()
                    //     return
                    // }
                    
                    // start_at & end_at不得為非法字元，停住
                    if (!newValue.start_at || !newValue.end_at) {
                        this.clearTimer()
                        return
                    }
                
                    // start_at 不得大於 end_at，停住
                    if (new Date(newValue.start_at).getTime() > new Date(newValue.end_at).getTime()) {
                        this.clearTimer()
                        return
                    }

                    this.resetTimer(newValue)
                    
                }
            }
        }
        
	}
</script>
<style scoped>
.count_timer_container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: red;
	width: 100%;
}
.count_timer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 1em 0px;
}
.count_timer_header {
	text-align: center;
	font-size: 12px;
}
.description {
	font-weight: bold;
	/* -webkit-background-clip: text;
	-moz-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;	 */
}
.count_timer_body {
	display: flex;
	flex-direction: row;
	justify-content: center;
    line-height: 1 !important;
}
.count_timer_header , .count_timer_body {
	margin: 1em 0px;
}
.count_timer_header {
	margin-bottom: 0em
}
.count_timer_body  {
	margin-top: 0.5em;
}
.units_container {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.symbol_container {
	margin: 0px 5px;
}
.units_container > div {
	text-align: center;
}
.number {
	font-size: 28px;
	font-weight: bold;
	-webkit-background-clip: text;
	-moz-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;	
	background-color: #000;	
}
.unit {
	font-size: 18px;	
}
.symbol {
	position: relative;
	font-size: 27px;
	/* -webkit-background-clip: text;
	-moz-background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;
	background-color: #000;			 */
}
.sec {
	color: red;
}
.emoji {
	-webkit-text-fill-color: initial;
}
.card-subtitle {
    padding-left: 0px !important;
}
</style>